import React from 'react';
import QueueAnim from 'rc-queue-anim';
import { Row, Col } from 'antd';
import OverPack from 'rc-scroll-anim/lib/ScrollOverPack';
import { getChildrenToRender, isImg } from '../utils';
import {Link} from "react-router-dom";

class IndustrySolutions extends React.PureComponent {
    selectTab = () =>{
        sessionStorage.setItem("activeTab","行业方案")
    }
  getBlockChildren = (data) =>
    data.map((item, i) => {
      const { titleWrapper, ...$item } = item;
      return (
        <Col key={i.toString()} {...$item}>
          {titleWrapper.children.map(getChildrenToRender)}
        </Col>
      );
    });


  render() {
    const { ...props } = this.props;
    const { dataSource } = props;
    delete props.dataSource;
    delete props.isMobile;
    const listChildren = this.getBlockChildren(dataSource.block.children);
    return (
      <div {...props} {...dataSource.wrapper}>
        <div {...dataSource.page}>
          <div {...dataSource.titleWrapper} style={{fontSize:16,color:'rgba( 0, 0, 0, 0.85)'}}>
              <Link to={dataSource.titleWrapper.url} onClick={() => this.selectTab()}>
                  <Row type="flex" justify="center">
                    <div className="home_title">
                      {dataSource.titleWrapper.children.map(getChildrenToRender)}
                    </div>
                  </Row>
              </Link>
          </div>
          <OverPack {...dataSource.OverPack}>
            <Row type="flex" justify="space-between" className="block-wrapper">
              {listChildren}
            </Row>
          </OverPack>
        </div>
      </div>
    );
  }
}

export default IndustrySolutions;
